module.exports = __webpack_public_path__ + "static/img/mjigou.daf5b40c.png";